import Util from '../RegistrationUtil'
import Field from '../RegistrationField'
import { getEnv } from 'aria-viewer/utils/environment'

// The "SCHOOL" field in our registration form;
// used for autocomplete

// TODO: #1 deprecate in favor of material-ui AutoComplete
// TODO: which can also help cut down our dependencies
// TODO: and make app more efficient

// TODO: #2 extend base form functionality so that
// TODO: we do not have to do things like this file

function School(opts) {
    Field.call(this, opts)

    this.$input = this.$html.find('.input')
    this.$frame = this.$html.find('.frame')
    this.$list = this.$html.find('.list')
    this.$searching = this.$html.find('.searching')
    this.$notInList = this.$html.find('.not-in-list')
    this.onResumePageScroll = opts.registration._onResumePageScroll //apply options for autoComplete
}

Util.inherit(School, Field, {
    getClassName: function() {
        return 'textbox school'
    },

    buildHtml: function() {
        var html =
            '' +
            '<input class="input" name="school_name" type="text" ' +
            this._getPlaceholderText(true) +
            '" id="' +
            this._getId() +
            '" />' +
            '<div class="searching">searching...</div>' +
            '<div class="frame">' +
            '<div class="list"></div>' +
            '<a style="text-decoration:none">' +
            '<div class="not-in-list">' +
            'Use my school name' +
            '</div>' +
            '</a>' +
            '</div>'

        return html
    },

    applyBindings: function() {
        var that = this
        var cache = {}
        var query

        var $input = this.$input

        // OPEN AUTOCOMPLETE WHEN FOCUSED
        $input.on('focus', function(evt) {
            $input.autocomplete('search', $input.val())
        })

        $input.on('change', function(evt) {
            var cachedResponse = cache[query]
            var school = cachedResponse && cachedResponse.find(school => school.value == $input.val())

            // Use the cached school response if available
            var value = school ? school : $input.val()
            $input && $input.setValue && $input.setValue(value)
            that && that.setValue && that.setValue(value)
        })

        // REMOVE LIST SELECTION QUICKER THAN DEFAULT
        // -NEEDED FOR "CAN'T FIND SCHOOL?" OPTION
        this.$frame.on('mouseleave', '.ui-autocomplete', function(evt) {
            that.$frame.find('.ui-state-focus').removeClass('ui-state-focus')
        })

        $input.autocomplete({
            minLength: 1,
            appendTo: this.$list,
            autoFocus: true,
            create: function(evt, ui) {
                $input.data('ui-autocomplete')._renderItem = function(ul, item) {
                    return $('<li><a>' + item.label + '</a></li>')
                        .data('item.autocomplete', item)
                        .appendTo(ul)
                }
            },
            source: function(request, response) {
                query = $input.val()
                if (cache[query]) {
                    response(cache[query])
                } else {
                    that.$searching.addClass('show')

                    Util.ajax({
                        url: `${getEnv('REACT_APP_BASE_URL')}/tour/Registration/ajaxGetSchools`,
                        data: { q: query },
                        success: function(res) {
                            that.$searching.removeClass('show')

                            var items = []
                            for (var i = 0, ii = res.data.length; i < ii; ++i) {
                                var s = res.data[i]

                                var camelName = that._toCamelCase(s.name)

                                items.push({ label: camelName, value: camelName, ceebcode: s.code })
                            }

                            cache[query] = items
                            response(items)
                        },
                    })
                }
            },

            select: function(evt, ui) {
                var TABKEY = 9
                if (evt.keyCode == TABKEY) {
                    // PREVENT SCHOOL FROM LIST BEING SELECTED
                    evt.preventDefault()
                } else {
                    $input.val(ui.item.label)
                    that.setValue(ui.item.ceebcode)
                    that.onResumePageScroll()
                }
            },

            open: function(evt, ui) {
                $('.ui-autocomplete').off('menufocus hover mouseover mouseenter')
                that.$frame.show()
            },

            close: function(evt, ui) {
                that.$frame.hide()
            },
        })

        $input.on('focus', this.focus.bind(this))
        $input.on('blur', this.blur.bind(this))

        // add callback to "Use my current school" option for resume scroll
        this.$notInList.on('click touchstart', function() {
            that.onResumePageScroll()
        })

        /*

			TODO : THESE WERE RELATED TO LOGIC TO FIX THE IOS KEYBOARD ISSUES;
			TODO : HAVE A FEW THINGS TO SORT OUT BUT A GOOD STARTING DIRECTION:
			TODO : (check Registration.js for other code snippet)

		// if focus changed
		this.$frame.on('blur', function(){
			that.$frame.hide();
			that.onResumePageScroll();
		});

		// if enter key pressed
		this.$input.on('keypress', function(e){
			if(e.keyCode == 13) {
				that.onResumePageScroll();
			}
		});

		$( window ).resize(that.onResumePageScroll);
		*/
    },

    _toCamelCase: function(str) {
        return str
            ? str.replace(/\w\S*/g, function(txt) {
                  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
              })
            : ''
    },
})

export default School
